document.addEventListener('turbolinks:load', () => {
  const form = document.getElementById('nomination-form-overrides-form');
  const checkbox = document.getElementById('nomination-form-use-date-overrides');
  const fieldsContainer = document.getElementById('nomination-form-override-fields');

  if (!form || !checkbox || !fieldsContainer) return;

  const overrideInputs = Array.from(fieldsContainer.querySelectorAll('input'));

  const formatDate = (value) => {
    if (!value) return '—';
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const formatTime = (value) => {
    if (!value) return '5:00 PM';
    const [hour, minute] = value.split(':').map(Number);
    const date = new Date();
    date.setHours(hour, minute, 0, 0);
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit'
    });
  };

  const updateFieldState = () => {
    const enabled = checkbox.checked;
    fieldsContainer.classList.toggle('opacity-50', !enabled);

    overrideInputs.forEach((input) => {
      input.disabled = !enabled;
    });
  };

  const syncAppliedPreview = () => {
    const mappings = [
      ['override_deadline_date', 'applied-deadline-date', formatDate],
      ['override_deadline_time', 'applied-deadline-time', formatTime],
      ['override_pre_ballot_date', 'applied-pre-ballot-date', formatDate],
      ['override_ballot_date', 'applied-ballot-date', formatDate]
    ];

    mappings.forEach(([fieldName, outputId, formatter]) => {
      const input = form.querySelector(`[name="nomination_form[${fieldName}]"]`);
      const output = document.getElementById(outputId);
      if (!input || !output) return;

      if (!checkbox.checked || !input.value) {
        output.textContent = output.dataset.defaultValue || '—';
        return;
      }

      output.textContent = formatter(input.value);
    });
  };

  checkbox.addEventListener('change', () => {
    updateFieldState();
    syncAppliedPreview();
  });

  overrideInputs.forEach((input) => {
    input.addEventListener('input', syncAppliedPreview);
  });

  updateFieldState();
  syncAppliedPreview();
});
